import { jsx } from 'react/jsx-runtime';
import { BaseTileName } from '@vp/swan';

const TemplateTileTitle = ({ children }) => /* @__PURE__ */ jsx(BaseTileName, { mb: 4, children });

export { TemplateTileTitle };
